import { useOrgMetadata, type OrgMetadata } from "./use-org-metadata";

interface UseOrgResult {
  org: OrgMetadata | null;
  isLoading: boolean;
  error: string | null;
  updateOrg: (data: Partial<OrgMetadata>) => Promise<void>;
  isUpdating: boolean;
}

export const useOrg = (): UseOrgResult => {
  const { metadata, updateMetadata, isLoading, error } = useOrgMetadata();

  return {
    org: metadata,
    isLoading,
    error,
    updateOrg: updateMetadata,
    isUpdating: isLoading,
  };
};

export default useOrg;
